import React from 'react'
import Svg from './../Svg'

export default ({
  width = 25,
  height = 22,
  'aria-label': ariaLabel,
  className = '',
}) =>
  <Svg
    className={ className }
    width={ width }
    height={ height }
    viewBox="0 0 31 27"
    aria-label={ ariaLabel }
  >
    <path d="M31,0 L31,23.4 L24,23.4 L26.3,25.7 L25,27 L21.5,23.4 L9.6,23.4 L6.1,27 L4.8,25.6 L7,23.4 L0,23.4 L0,0 L31,0 Z M29.2,1.9 L1.8,1.9 L1.8,21.5 L29.2,21.5 L29.2,1.9 Z M15.5,5.8 C17.7,5.8 19.5,7.6 19.5,9.8 C19.5,10.9 19,12 18.1,12.8 C18.9,13.1 19.6,13.6 20.2,14.2 C21.5,15.5 22.2,17.2 22.2,19 L22.2,19 L22.2,19.2 L20.7,19.2 L20.7,19 C20.7,16.1 18.4,13.8 15.5,13.8 C12.6,13.8 10.3,16.1 10.3,19 L10.3,19 L10.3,19.2 L8.8,19.2 L8.8,19 C8.8,17.2 9.5,15.5 10.8,14.2 C11.4,13.6 12.1,13.1 12.9,12.8 C12,12.1 11.5,11 11.5,9.8 C11.5,7.6 13.3,5.8 15.5,5.8 Z M15.5,7.2 C14.1,7.2 13,8.3 13,9.7 C13,11.1 14.1,12.2 15.5,12.2 C16.9,12.2 18,11.1 18,9.7 C18,8.3 16.9,7.2 15.5,7.2 Z"/>
  </Svg>
